module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promo columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.handleDeletePromo
    }
  }), _vm._v(" "), _c('b-switch', {
    on: {
      "change": _vm.handleUpdatePromo
    },
    model: {
      value: (_vm.promoObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "isHidden", $$v)
      },
      expression: "promoObject.isHidden"
    }
  }, [_vm._v("Скрыть акцию с сайта")]), _vm._v(" "), _c('span', {
    staticClass: "picker-label"
  }, [_vm._v("Время проведения акции")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetimerange",
      "placeholder": "Время проведения акции"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-flex"
  }, [_c('b-switch', {
    model: {
      value: (_vm.promoObject.publishLater),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "publishLater", $$v)
      },
      expression: "promoObject.publishLater"
    }
  }, [_vm._v("Опубликовать позже")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "publish-date-picker",
    attrs: {
      "type": "datetime",
      "editable": false,
      "placeholder": "Дата и время публикации"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.publishDate),
      callback: function($$v) {
        _vm.publishDate = $$v
      },
      expression: "publishDate"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    staticClass: "title",
    attrs: {
      "placeholder": "Название акции",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdatePromo
    },
    model: {
      value: (_vm.promoObject.title),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "title", $$v)
      },
      expression: "promoObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Условия акции",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdatePromo
    },
    model: {
      value: (_vm.promoObject.conditions),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "conditions", $$v)
      },
      expression: "promoObject.conditions"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "promo-button-wrapper",
    attrs: {
      "label": "Параметры кнопки"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка на страницу, если нужна"
    },
    on: {
      "change": _vm.handleUpdatePromo
    },
    model: {
      value: (_vm.promoObject.url),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "url", $$v)
      },
      expression: "promoObject.url"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Название кнопки"
    },
    on: {
      "change": _vm.handleUpdatePromo
    },
    model: {
      value: (_vm.promoObject.urlButton),
      callback: function($$v) {
        _vm.$set(_vm.promoObject, "urlButton", $$v)
      },
      expression: "promoObject.urlButton"
    }
  })], 1), _vm._v(" "), _c('b-field'), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSavePromo()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41be71a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promos/Promo.vue
// module id = 937
// module chunks = 0